import { $Q, $Qll } from "graditify-utils";

const animElements = $Qll(".js-anim-stair");

export default function animateStair() {
  animElements.forEach((element) => {
    const intersectionObserver = new IntersectionObserver((e) => {
        const nodes = Array.from(element.children);
        if (e[0].isIntersecting) {
          nodes.forEach((node) => {
            const child = $Q('.sub-child-animate', node)
            if (child) return child.classList.add('animate')

            node.classList.add("animate")
          })
        }
      })
    intersectionObserver.observe(element)
  });
}
